import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../Lib/Object/deepEquals';
import { Field, NumericInput, RadioGroup, TextOutput } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { Grid, GridFieldSection, ListFieldSection } from '../../../Layout';
import { WorksheetEquipmentDropdown } from '../../Core';
import { WorksheetBalanceFieldSet } from '../../Core/WorksheetEquipment';
import ids from '../../QestIds';

const qestIds = [ids.oversizeDetermination.ARIZ_225d_245c];

let MeasuredOversizeDeterminationWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const sieves = useSelector(createWorksheetSelector!('Sieves'), deepEquals);
  const isSieveAvailable = useCallback(
    (sieveId: any) => sieves && sieves.some((s: any) => s.SieveId === sieveId && s.IsAvailable),
    [sieves]
  );

  const allSieves = useSelector(createWorksheetSelector!('AllSieves'), deepEquals);
  const sieveMassType = useSelector(createWorksheetSelector!('SieveMassType'));

  const getRowHeaders = () => {
    if (!allSieves) return [];
    return allSieves.map((s: any) => s.Caption);
  };

  const getGridData = () => {
    if (!allSieves) return [];
    return allSieves.map((sieveDef: any, index: any) => [
      <Field
        emph
        input={<WorksheetEquipmentDropdown />}
        label="Sieve"
        equipmentType="sieve"
        name={`Sieves[${index}].Sieve`}
        queryParams={{ SieveSize: `${sieveDef?.Size.value} ${sieveDef?.Size.uom}` }}
        disabled={!isSieveAvailable(sieveDef.Id)}
      />,
      <Field
        input={<NumericInput />}
        disabled={!isSieveAvailable(sieveDef.Id)}
        name={`Sieves[${index}].DryMassRetained`}
        label={`${sieveMassType === 'cumulative' ? 'Cumulative' : 'Individual'} Mass Retained`}
      />,
      <Field
        input={<TextOutput />}
        name={`Sieves[${index}].CumulativeDryMassRetainedPercent`}
        label="Cumulative Mass Retained (%)"
      />,
    ]);
  };

  return (
    <>
      <ListFieldSection>
        <WorksheetBalanceFieldSet emph label="Oversize Balance" name="Equipment.Balance" />
      </ListFieldSection>
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          label="Sieve masses are:"
          name="SieveMassType"
          options={['Cumulative', 'Individual'].map((e) => ({ label: e, value: e.toLowerCase() }))}
        />
        <Field input={<NumericInput />} label="Total Sample Mass" name="TotalMaterialDryMass" />
      </ListFieldSection>
      <GridFieldSection>
        <Grid
          cornerHeader="Sieve Size"
          colHeaders={[
            'Sieve',
            `${sieveMassType === 'cumulative' ? 'Cumulative' : 'Individual'} Mass Retained (g)`,
            'Cumulative Mass Retained (%)',
          ]}
          colWidths={[200, 130]}
          rowHeaders={getRowHeaders()}
          rowHeaderWidth={110}
          data={getGridData()}
        />
      </GridFieldSection>
    </>
  );
};

MeasuredOversizeDeterminationWorksheet = withInjectedProps(MeasuredOversizeDeterminationWorksheet);

MeasuredOversizeDeterminationWorksheet.qestIds = qestIds;

export default MeasuredOversizeDeterminationWorksheet;
export { MeasuredOversizeDeterminationWorksheet };
